import { useQueryClient } from "@tanstack/react-query";

import { usePostTestingControls } from "api/generated/testing-controls/testing-controls";

import { TESTING_CONTROLS_QUERY_KEY } from "../../list/queries/useTestingProgramTestingControlsQuery";

export function useCreateTestingControlMutation() {
    const queryClient = useQueryClient();
    return usePostTestingControls({
        mutation: {
            onSuccess: () => {
                queryClient.invalidateQueries({
                    queryKey: [TESTING_CONTROLS_QUERY_KEY],
                });
            },
        },
    });
}
